import React, { useCallback, useEffect, useMemo } from 'react';
import { DefaultQueryParams, isMobile, MainWr, parseQuery } from '@pascal/pascal-core';
import { popupStore } from '@pascal/pascal-core/shared/core/store';
import { BrowserRouter } from 'react-router-dom';
import { Factory } from './core';
import { WebGame } from './containers/webGame';
import { TableLobbyWr } from './containers/lobby';
import { gameService } from './services';
import { RoutePaths } from './enums/routes';
import { MobileGame } from './containers/mobileGame';
import { TURBO_GAME_ID } from './enums/constants';

function App() {
  const { [DefaultQueryParams.GameId]: gameId } = parseQuery(window.location.search);
  const isTurbo = +gameId === TURBO_GAME_ID;

  const components = useMemo(
    () => [
      {
        path: isTurbo ? `${RoutePaths.lobby}lobby` : RoutePaths.lobby,
        element: <TableLobbyWr />,
        defaultRedirectComponent: !isTurbo,
      },
      {
        path: isTurbo ? RoutePaths.turbo : RoutePaths.game,
        element: isMobile() ? <MobileGame /> : <WebGame />,
        defaultRedirectComponent: isTurbo,
      },
    ],
    [isTurbo]
  );

  const lostInternetConnection = useCallback(() => {
    // popupStore.open({ name: PopUps.ConnectionError });
    popupStore.onConnectionError(true);
  }, []);

  const reconnectInternet = useCallback(() => {
    gameService.socketRecursiveReconnecting();
  }, []);

  useEffect(() => {
    window.addEventListener('offline', lostInternetConnection);
    window.addEventListener('online', reconnectInternet);
    return () => {
      window.removeEventListener('offline', lostInternetConnection);
      window.removeEventListener('online', reconnectInternet);
    };
  }, [lostInternetConnection, reconnectInternet]);

  return (
    <BrowserRouter>
      <MainWr>
        <Factory components={components} />
      </MainWr>
    </BrowserRouter>
  );
}

export default App;
